import configHandler from '../../configHandler'

const ERROR_TOO_LONG = 'tooLong'
const ERROR_TOO_SHORT = 'tooShort'

const parse = (text) => {
    return {
        input: text,
        isRequired: false,

        required: function () {
            this.isRequired = true
            return this
        },

        parsed: function () {
            return this.input.trim()
        },

        isValid: function () {
            return this.validate().length === 0
        },

        validate: function () {
            const errors = []
            if (!this.parsed().length && this.isRequired) {
                errors.push(configHandler.errorMessages().text[ERROR_TOO_SHORT])
            }

            if (this.parsed().length > 255) {
                errors.push(configHandler.errorMessages().text[ERROR_TOO_LONG])
            }
            return errors
        },

        value: function () {
            return String(this.input)
        },

        format: function () {
            return String(this.parsed())
        },
    }
}

export default {
    parse,
}